import "./style/index.scss";
import "@mobiscroll/react/dist/css/mobiscroll.min.css";
import { Eventcalendar, MbscCalendarEvent, MbscEventcalendarView, localePtBR, Popup, MbscPopupDisplay } from "@mobiscroll/react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Flex, Form, Menu, MenuProps, Modal, Radio, Row } from "antd";
import * as Icon from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import CadastroCompromissoFiscal from "./modals/cadastrar";
import { AgendaModel } from "../../models/agenda/agendaModel";
import { buscarAgenda, deletarAgenda } from "../../services/agendaService";
import {
  setEntityAgendaCompromissoFiscal,
  setModalCadastrarAgendaCompromissoFiscal,
  setModalDeletarAgendaCompromissoFiscal,
} from "../../redux/slices/agendaCompromissoFiscal/agendaCompromissoFiscalSlice";
import MensagemModal from "../../components/modal/mensagem";
import { ButtonComponent } from "../../components/button/cadastrar";

type MenuItem = Required<MenuProps>["items"][number];

const AgendaCompromissoFiscal = () => {
  //estados globais
  const agendaCompromissoFiscalState = useAppSelector((state) => state.agendaCompromissoFiscal);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [isOpen, setAbrirPopup] = useState<boolean>(false);
  const [anchor, setAnchor] = useState<any>(null);
  const [tempEvent, setTempEvent] = useState<any>(null);
  const [selectedOption, setSelectedOption] = useState("S");

  const editar = Object.values(agendaCompromissoFiscalState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("AGENDA DE OBRIGAÇÕES FISCAIS"));
    dispatch(buscarAgenda(agendaCompromissoFiscalState.busca));
  }, []);

  const agenda: any[] = agendaCompromissoFiscalState.list;

  const calendario = useMemo<MbscEventcalendarView>(() => {
    return {
      calendar: {
        type: selectedOption === "S" ? "week" : "month",
        labels: "all",
      },
      agenda: { type: "day" },
    };
  }, [selectedOption]);

  const compromissos = agenda.map((item: any): MbscCalendarEvent => {
    return {
      allDay: true,
      showText: true,
      color: "#334155",
      id: item.id,
      date: item.dataCompromisso,
      title: item.descricao,
      original: item,
    };
  });

  const goCadastrar = () => {
    dispatch(setEntityAgendaCompromissoFiscal({}));
    dispatch(setModalCadastrarAgendaCompromissoFiscal(true));
  };

  const goEditar = (entity: any) => {
    setAbrirPopup(false);
    dispatch(setEntityAgendaCompromissoFiscal(entity.original));
    dispatch(setModalCadastrarAgendaCompromissoFiscal(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarAgendaCompromissoFiscal(false));
  };

  const goDeletar = (value: AgendaModel) => {
    setAbrirPopup(false);
    dispatch(setEntityAgendaCompromissoFiscal(value));
    dispatch(setModalDeletarAgendaCompromissoFiscal(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarAgendaCompromissoFiscal(false));
  };

  const onMenuClick = (e: { key: string }, record: AgendaModel) => {
    if (e.key === "1") {
      goEditar(record);
    } else {
      goDeletar(record);
    }
  };

  const items: MenuItem[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
    },
  ];

  const loadPopupForm = useCallback((event: MbscCalendarEvent) => {}, []);

  const onEventClick = useCallback(
    (event: any) => {
      setTempEvent({ ...event.event });
      loadPopupForm(event.event);
      setAnchor(event.domEvent.target);
      setAbrirPopup(true);
    },
    [loadPopupForm]
  );

  const responsivePopup = {
    medium: {
      display: "anchored" as MbscPopupDisplay,
      width: 60,
      fullScreen: false,
      touchUi: false,
    },
  };

  const onClose = useCallback(() => {
    setAbrirPopup(false);
  }, []);

  return (
    <Flex vertical>
      <Form layout="vertical">
        <Row gutter={12}>
          <Col span={4}>
            <Form.Item label=" ">
              <Radio.Group buttonStyle="solid" onChange={(e) => setSelectedOption(e.target.value)} value={selectedOption}>
                <Radio.Button value="S">Semanal</Radio.Button>
                <Radio.Button value="M">Mensal</Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={20}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar}> CADASTRAR NOVA OBRIGAÇÃO FISCAL</ButtonComponent>
            </Flex>
          </Col>
        </Row>
      </Form>
      <Eventcalendar theme="windows" themeVariant="light" locale={localePtBR} data={compromissos} view={calendario} onEventClick={onEventClick} />
      <Modal
        title={editar ? "EDITAR OBRIGAÇÃO FISCAL" : "NOVA OBRIGAÇÃO FISCAL"}
        centered
        width={900}
        open={agendaCompromissoFiscalState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroCompromissoFiscal />
      </Modal>
      <Modal title={"REMOVER OBRIGAÇÃO FISCAL"} centered width={350} open={agendaCompromissoFiscalState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover a obrigação fiscal?"
          action={deletarAgenda({ value: agendaCompromissoFiscalState.entity.id, busca: agendaCompromissoFiscalState.busca })}
          close={setModalDeletarAgendaCompromissoFiscal(false)}
        />
      </Modal>
      <Popup display="bottom" fullScreen={true} contentPadding={false} anchor={anchor} isOpen={isOpen} onClose={onClose} responsive={responsivePopup}>
        <Menu items={items} onClick={(e) => onMenuClick(e, tempEvent)} />
      </Popup>
    </Flex>
  );
};

export default AgendaCompromissoFiscal;
